// extracted by mini-css-extract-plugin
export default {"content":"UH-z","lookName":"VH-z","shopTheLookContainer":"WH-z","productContainer":"XH-z","imageContainer":"YH-z","mainImage":"ZH-z"};